import React from "react";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from 'react-perfect-scrollbar'
import "../../layout/AuthLayout/authLayout.css";
import ComingSoon from "../../assests/new-images/coming-soon.webp"
export default function ExchangeRatesFeature() {
  const { t } = useTranslation();

  return (
    <>
      <div className="" style={{ height: "inherit" }}>
        <div className="auth-card ">
          <PerfectScrollbar>
            <div className="mb-2 p-4" align="center">
              <h3 align="center" className="password-text">
                {t("pages.landing.exchange", {
                  defaultValue: "Exchange Rates",
                })}
              </h3>
              <img align="center"
                height={300}
                alt="ComingSoon"
                src={ComingSoon}
              />

              <h3 align="center" className="password-text">
                Stay Tuned, Something awesome is coming soon!!
              </h3>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
}
